export default __webpack_public_path__ + "static/media/151-archives.db7f6ca5.png";